import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ConfirmModal = ({ data, isOpen, toggle, onConfirm, status, isPub }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Change Status</ModalHeader>
      <ModalBody>
        Are you sure you want to{" "}
        {isPub ? (
          <>
            <Badge color={`${data?.isPublish ? "outline-warning" : "outline-success"}`}>
              {data?.isPublish ? "Archive " : "Publish "}
            </Badge>
          </>
        ) : (
          <span
            className={
              status == "active" || status === true ? `text-primary text-capitalize` : `text-success text-capitalize`
            }
          >
            {status == "active" || status === true ? "deactivate " : "activate "}
          </span>
        )}
        this?
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color={
            status === "active" || status === true
              ? "primary"
              : status === "inactive" || status === false || status == "Inactive"
              ? "success"
              : "danger"
          }
          onClick={onConfirm}
        >
          Yes,{" "}
          {isPub
            ? data?.isPublish
              ? "Archive"
              : "Publish"
            : status == "active" || status === true
            ? "Deactivate"
            : "Activate"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
